import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-timeline-transport-artic-make-daily',
    templateUrl: './timeline-transport-artic-make-daily.component.html',
    styleUrls: ['./timeline-transport-artic-make-daily.component.scss'],
    standalone: false
})
export class TimelineTransportArticMakeDailyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
